import 'angular';
import 'angular-animate';
import 'angular-resource';
import 'angular-route';
import 'angular-sanitize';
import 'angular1-async-filter';
import 'babel-polyfill';
import 'jquery';
import 'jquery.cookie';
import 'lodash';
import 'rxjs';
import 'whatwg-fetch';

// Legacy modules
import 'angular-dynamic-locale';
import 'bootstrap/bootstrap.js';
require('bootstrap/css/bootstrap.css');
require('bootstrap/css/bootstrap-responsive.css');
// jQuery.flexslider
import 'jquery.flexslider';
require('jquery.flexslider/flexslider.css');
// Overthrow
import 'overthrow';
import 'sir-trevor-adapter';
import 'snap';
require('snap/snap.css');



// WEBPACK FOOTER //
// ./src/vendor.js